import React from 'react';

/**
 * Cockpit Switch — pill toggle, thumb springs across, track warms to rust.
 */
export interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export default function Switch({ checked = false, onChange, label, disabled = false, style }: SwitchProps) {
  return (
    <label
      className="ck-switch pressable"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        userSelect: 'none',
        ...style,
      }}
    >
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.checked)}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
      />
      <span
        style={{
          position: 'relative',
          width: '36px',
          height: '21px',
          borderRadius: 'var(--radius-pill)',
          background: checked ? 'var(--accent)' : 'var(--surface-active)',
          border: '1px solid ' + (checked ? 'transparent' : 'var(--border-hairline)'),
          transition: 'background var(--dur-base) var(--ease-out)',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '2px',
            left: checked ? '17px' : '2px',
            width: '15px',
            height: '15px',
            borderRadius: 'var(--radius-pill)',
            background: '#FFFFFF',
            boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
            transition: 'left var(--dur-base) var(--ease-spring)',
          }}
        />
      </span>
      {label ? <span style={{ fontSize: 'var(--text-base)', color: 'var(--text-body)' }}>{label}</span> : null}
    </label>
  );
}
